module.exports = __webpack_public_path__ + "img/DE00732.8fc65877.png";